import axios, { getAuthHeaders, getFormDataHeaders } from './config';


export default {
    all: function() {
        return axios.get('/users', {
            headers: getAuthHeaders()
        })
    },

    allUsers: function() {
        return axios.get('/all-users', {
            headers: getAuthHeaders()
        })
    },

    store: function(user) {
        return axios.post('/users', user, {
            headers: getAuthHeaders()
        })
    },

    show: function(userID) {
        return axios.get(`/users/${userID}`, {
            headers: getAuthHeaders()
        })
    },
    update: function(data) {
        return axios.put(`/users/${data.userId}`, data, {
            headers: getAuthHeaders()
        })
    },
    updateProfile: function(data) {
        return axios.post(`/users-profile`, data, {
            headers: getAuthHeaders()
        })
    },

    getPicture: function(userId) {
        return axios.get(`/profile/${userId}`, {
            responseType: 'blob',
            headers: getAuthHeaders()
        })
    },

    updatePicture: function(userPicture) {
        return axios.post(`/profile`, userPicture, {
            headers: getFormDataHeaders()
        })
    },

    updateUserStatus: function(userId) {
        return axios.put(`/users/status/${userId}`, null, {
            headers: getAuthHeaders()
        });
    },

    getAllPermissions: function(dirname) {
        return axios.post(`/groups-permissions`, {
            dirname: dirname
        }, {
            headers: getAuthHeaders()
        });
    },

    updatePermission: function(data) {
        return axios.put('/groups-permissions', data, {
            headers: getAuthHeaders()
        });
    },

    retrieve: function() {
        return axios.get(`/auth-user`, {
            headers: getAuthHeaders()
        })
    },

    resetPassword: function(user) {
        return axios.post(`/users/reset-password`, user, {
            headers: getAuthHeaders()
        })
    },

    getAllNotifications: function() {
        return axios.get(`/notifications`, {
            headers: getAuthHeaders()
        })
    },

    sendNotif: function(notif) {
        return axios.post('/notifications', notif, {
            headers: getAuthHeaders()
        });
    },

    delaynotif: function(notificationID) {
        return axios.get(`/notifications/show/${notificationID}`, {
            headers: getAuthHeaders()
        })
    },
    updateNotifications: function(notificationID) {
        return axios.put(`/notifications/${notificationID}`, {}, {
            headers: getAuthHeaders()
        })

    },

    delete: function(userID) {
        return axios.delete(`/users/${userID}`, {
            headers: getAuthHeaders()
        })
    },

    addDirectories: function() {
        return axios.get(`/directories`, {
            headers: getAuthHeaders()
        })
    },

    logoutUser: function(user) {
        return axios.post(`/logout`, user, {
            headers: getAuthHeaders()
        });
    },

    login: function(email, password) {
        return axios.post(`/login`, { email, password }, {
            headers: getAuthHeaders()
        });
    },

    counterUser: function() {
        return axios.get('/user', {
            headers: getAuthHeaders()
        })
    },
}